/* ==========================================================================
   ModalSearcher > Client > Prototype
   ========================================================================= */
/* Modules */
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { Store } = require('@bluekiri/alexandria/helpers/state');
const imageTemplate = require('@bluekiri/alexandria-contrib-components/components/image-rxjs/template');
const ImageClient = require('@bluekiri/alexandria-contrib-components/components/image-rxjs/client/js');
const priceTemplate = require('../../../price/template');

const { reducer } = require('./store/reducer');
const { types, actions } = require('./store/actions');

const prototype = {
    searcherClient(type) {
        switch (type) {
            case 'SearcherFlightHotel':
                return module.require('../../../searcher-flight-hotel/client/js');
            case 'SearcherFerryHotel':
                return module.require('../../../searcher-ferry-hotel/client/js');
            case 'SearcherTrainHotel':
                return module.require('../../../searcher-train-hotel/client/js');
            case 'SearcherBusHotel':
                return module.require('../../../searcher-bus-hotel/client/js');
            default:
                return null;
        }
    },
    /**
     * set
     * @param {string} rendered content
     * @returns {object} Current instanace
     */
    set(title = false, body = false) {
        if (title) this.setTitle(title);
        if (body) this.setBody(body);

        return this;
    },
    /**
     * setBody
     * @param {string} rendered content
     * @returns {object} Current instanace
     */
    setBody(body = '') {
        const bodyEl = this.element.querySelector('[data-body]');

        bodyEl.parentNode.replaceChild(
            toNode(/* html */ ` <div class="${this.config.css.modalBody}" data-body>${body}</div>`)[0],
            bodyEl
        );

        return this;
    },
    /**
     * setTitle
     * @param {string} title
     * @returns {object} Current instanace
     */
    setTitle(title = '') {
        const headerEl = this.element.querySelector('[data-header]');

        headerEl.parentNode.replaceChild(
            toNode(/* html */ ` <p class="${this.config.css.headerTitle}" data-header>${title}</p>`)[0],
            headerEl
        );
    },
    onOpen() {
        setTimeout(() => {
            if (!this.image) this.image = ImageClient(this.config.selector.image);
        }, 250);
    },
    onClose() {},
    /**
     * Add event listener
     * @returns {object} Current instance
     */
    addEventListener: function addEventListener() {
        this.modal.addEventListener();

        return this;
    },
    /**
     * Remove event listener
     * @returns {object} Current instance
     */
    removeEventListener: function removeEventListener() {
        this.modal.removeEventListener();

        return this;
    },

    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            modalSearcher: reducer
        });

        return this;
    },

    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            setTitle: title => this.store.dispatch(actions.setTitle(title)),
            setImage: image => this.store.dispatch(actions.setImage(image)),
            setPrice: price => this.store.dispatch(actions.setPrice(price)),
            setSearcher: searcher => this.store.dispatch(actions.setSearcher(searcher))
        };

        return this;
    },

    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Remove from DOM */
                this.element.parentNode.removeChild(this.element);
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Unsubscribe */
                this.unsubscribe();

                /* Clean itself */
                [...Object.keys(this)].forEach(key => {
                    delete this[key];
                });
            }),

            setTitle: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_TITLE) return;

                if (this.hooks.title) this.hooks.title.innerText = action.payload;
            }),

            setImage: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_IMAGE) return;

                if (this.hooks.product) {
                    const imageData = {
                        ...action.payload,
                        config: {
                            ...action.payload.config,
                            context: this.config.context,
                            styles: [`${this.config.css.component}__${this.config.css.productSearcher}-image`]
                        },
                        resize: this.config.image.resize
                    };

                    const image = toNode(imageTemplate(imageData, this.config.context))[0];

                    if (this.image) {
                        this.image.actions.destroy();
                        delete this.image;
                    }

                    this.hooks.product.insertBefore(image, this.hooks.price);
                }
            }),
            setPrice: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_PRICE) return;

                const priceEl = this.element.querySelector('[data-component="Modal"] [data-component="Price"]');

                if (this.hooks.product) {
                    if (!action.payload) {
                        if (priceEl) this.hooks.product.removeChild(priceEl);
                    } else {
                        const priceData = {
                            ...action.payload,
                            config: {
                                styles: [
                                    this.config.css.modalPrice,
                                    `${this.config.css.component}__${this.config.css.productSearcher}-price`
                                ]
                            }
                        };

                        // render price
                        const price = toNode(priceTemplate(priceData, this.config.context))[0];
                        // remove old price
                        if (priceEl) this.hooks.product.removeChild(priceEl);
                        // add new price
                        this.hooks.product.appendChild(price);
                    }
                }
            }),
            setSearcher: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_SEARCHER) return;
                if (this.hooks.searcher) {
                    const searcher = toNode(action.payload)[0];
                    const searcherComponent = searcher.dataset.component;

                    /* require searcher client(flightHotel, ferryhotel, trainHotel or busHotel?) */
                    const searcherClient = this.searcherClient(searcherComponent);

                    if (this.searcher) {
                        this.hooks.searcher.removeChild(this.searcher.element);
                        delete this.searcher;
                    }

                    this.hooks.searcher.appendChild(searcher);

                    this.searcher = searcherClient(`[data-component="Modal"] [data-component="${searcherComponent}"]`, {
                        vehicle: { autoStore: false }
                    });
                }
            })
        };

        return this;
    },

    /* Subscribe */
    subscribe() {
        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {};

        return this;
    },

    /* Unsubcribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },

    /**
     * Start
     * @returns {object} Current instanace
     */
    start(cb = false) {
        this.modal.display();

        // run call back
        if (cb) cb(this);
    },

    init() {
        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();
    }
};

// Exports
module.exports = prototype;
